import React from 'react'
import LogoLink from 'components/logoLink'
import MobilePublicNavbarTrigger from 'components/modals/triggers/MobilePublicNavbarTrigger'

type PropType = {
    variant?: 'logo'
}

const MobilePublicNavbar = ({ variant = 'logo' }: PropType) => {
  return (
    <>
      <div className="flex w-full pt-5 pb-20 xl:pt-30">
        {variant === 'logo' && <LogoLink className="w-[191px] mx-auto mt-15" />}
        <MobilePublicNavbarTrigger variant={variant} />
      </div>
    </>
  )
}

export default MobilePublicNavbar
